import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
// import logo from "../assets/images/Logo-250/3.png";
import {
  CssBaseline,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
// import bg from "../assets/images/bg4.png";
import { Box, textAlign } from "@mui/system";
import logo from "../assets/images/bg2.png";

const PublicLayout = ({ children }) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      component="main"

      sx={{
    height: "100vh",
    display: "flex",
     width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    p: 4,
    position: "relative",
    backgroundImage: `url(${logo})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
    overflow: "hidden",
  }}
    >
      <CssBaseline />

       <Grid
        size={{xs:12}}
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        {children}
      </Grid>
    </Grid>

    
  );
};

export default PublicLayout;
